import React from 'react'
import { Row, Box } from '../../legacy-design-system/form'
import { css } from '@emotion/css'

export function LegacyPolicyPanel({
  children,
  outerFooter,
  testId
}: {
  readonly children: any
  readonly outerFooter?: any
  readonly testId?: string
}) {
  return (
    <React.Fragment>
      <section
        data-testid={testId ? testId : 'legacy-policy-panel'}
        className="drilldown panel panel-default table-dynamic table-responsive allow-overflow"
      >
        {children}
      </section>
      {!!outerFooter && (
        <Row>
          <Box>
            <div
              className={css`
                display: flex;
                flex-direction: row-reverse;
              `}
            >
              {outerFooter}
            </div>
          </Box>
        </Row>
      )}
    </React.Fragment>
  )
}

export function LegacyPolicyPanelBody({
  children
}: {
  readonly children: React.ReactNode | React.ReactNode[]
}) {
  return <div className="panel-body">{children}</div>
}
